import { render, staticRenderFns } from "./HomePC.vue?vue&type=template&id=7a566cfd&scoped=true"
import script from "./HomePC.vue?vue&type=script&lang=js"
export * from "./HomePC.vue?vue&type=script&lang=js"
import style0 from "./HomePC.vue?vue&type=style&index=0&id=7a566cfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a566cfd",
  null
  
)

export default component.exports